import { render, staticRenderFns } from "./HomeBook.vue?vue&type=template&id=2ac54b51&scoped=true&"
import script from "./HomeBook.vue?vue&type=script&lang=js&"
export * from "./HomeBook.vue?vue&type=script&lang=js&"
import style0 from "./HomeBook.vue?vue&type=style&index=0&id=2ac54b51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac54b51",
  null
  
)

export default component.exports